import { AppIcons } from '@web/ui/core/atoms';

interface BackButtonProps {
  label: string;
  onClick: () => void;
}

/**
 * BackButton — canonical `.v2-crumb-back` / `.np-back` leading control
 * that sits in topbars and editor headers. Mono eyebrow text, 24px
 * tall, no border, no `className` — every visual decision lives in
 * the molecule so the back affordance reads the same across every
 * screen.
 */
export function BackButton({ label, onClick }: Readonly<BackButtonProps>): React.JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex h-6 items-center gap-1.5 rounded-sm border-0 bg-transparent pl-1.5 pr-2 font-mono text-card-id uppercase tracking-eyebrow text-muted-foreground transition-colors duration-fast ease-standard hover:bg-subtle hover:text-foreground"
    >
      <AppIcons name="arrow-left" size={13} />
      <span>{label}</span>
    </button>
  );
}
